import React from 'react';

interface INoDataProps {
  dataType: string;
}

const NoDataFound: React.FC<INoDataProps> = ({ dataType }) => {
  return <p>No {dataType} found.</p>;
};

export default NoDataFound;
